import styles from "./tournament-info.module.css"

export default function TournamentInfo({ tournament }) {
  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoSection}>
        <h3 className={styles.sectionTitle}>Tournament Details</h3>

        <div className={styles.detailItem}>
          <span className={styles.label}>Tournament</span>
          <span className={styles.value}>{tournament.tournamentName}</span>
        </div>

        <div className={styles.detailItem}>
          <span className={styles.label}>Game</span>
          <span className={styles.value}>{tournament.game}</span>
        </div>

        <div className={styles.detailItem}>
          <span className={styles.label}>Format</span>
          <span className={styles.value}>{tournament.format}</span>
        </div>

        <div className={styles.detailItem}>
          <span className={styles.label}>Prize Pool</span>
          <span className={styles.value}>{tournament.prizePool}</span>
        </div>
      </div>

      <div className={styles.infoSection}>
        <h3 className={styles.sectionTitle}>Teams</h3>

        <div className={styles.teamCard}>
          <div className={styles.teamBadge}>Team 1</div>
          <h4 className={styles.teamName}>{tournament.team1}</h4>
          <div className={styles.teamStats}>
            <div className={styles.stat}>
              <span className={styles.statLabel}>Wins</span>
              <span className={styles.statValue}>24</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statLabel}>KDA</span>
              <span className={styles.statValue}>2.5</span>
            </div>
          </div>
        </div>

        <div className={styles.vsText}>VS</div>

        <div className={styles.teamCard}>
          <div className={styles.teamBadge}>Team 2</div>
          <h4 className={styles.teamName}>{tournament.team2}</h4>
          <div className={styles.teamStats}>
            <div className={styles.stat}>
              <span className={styles.statLabel}>Wins</span>
              <span className={styles.statValue}>22</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statLabel}>KDA</span>
              <span className={styles.statValue}>2.3</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.infoSection}>
        <h3 className={styles.sectionTitle}>Spectator Info</h3>

        <div className={styles.spectatorInfo}>
          <div className={styles.infoRow}>
            <span className={styles.icon}>👥</span>
            <span>{tournament.viewers.toLocaleString()} spectators watching</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.icon}>⏱️</span>
            <span>Match started 15 minutes ago</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.icon}>🎥</span>
            <span>Replay will be available after match</span>
          </div>
        </div>
      </div>
    </div>
  )
}
